module.exports = __webpack_public_path__ + "img/folder.dca2f3d4.svg";